/* eslint-disable */
const Twig = require('twig');

Twig.filters['locale'] = (key, args) => {
    const lang = args[0]; let locale = {};

    if (typeof window !== 'undefined') {
        if (!window.localeDictionary) {
            const text = document.querySelector('#locale').textContent;

            if (text) {
                window.localeDictionary = JSON.parse(text);
            }
        } locale = window.localeDictionary;
    } else {
        locale = JSON.parse(fs.readFileSync(`./src/locale/${lang}.json`));
    } if (locale?.[key]) {
        return locale[key];
    }

    return key;
}; const template = Twig.twig({id  : '0a3eb3a48391b56c6b091aab6fb1ebdb8cd53ca5ba3bd45999bcda74762baa723611726f928c34d35d71b7966b4dbf8241a3a14699f52b43601d5b550ecb48e6',
    data: [{type : 'raw',
        value: '<div class="flat-card'}, {type : 'logic',
        token: {type : 'Twig.logic.type.if',
            stack: [{type : 'Twig.expression.type.variable',
                value: 'class',
                match: ['class']}],
            output: [{type : 'raw',
                value: ' '}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'class',
                    match: ['class']}]}]}}, {type : 'raw',
        value: '">\n    '}, {type : 'logic',
        token: {type : 'Twig.logic.type.if',
            stack: [{type : 'Twig.expression.type.variable',
                value: 'url',
                match: ['url']}],
            output: [{type : 'raw',
                value: '        <a class="flat-card__url" href="'}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'url',
                    match: ['url']}]}, {type : 'raw',
                value: '"></a>\n    '}]}}, {type : 'raw',
        value: '    <div class="flat-card__title">'}, {type : 'output',
        stack: [{type : 'Twig.expression.type.variable',
            value: 'title',
            match: ['title']}, {type: 'Twig.expression.type.key.period',
            key : 'title'}]}, {type : 'raw',
        value: ' '}, {type : 'output',
        stack: [{type : 'Twig.expression.type.variable',
            value: 'title',
            match: ['title']}, {type: 'Twig.expression.type.key.period',
            key : 'value'}]}, {type : 'raw',
        value: '</div>\n    <div class="flat-card__params">\n        '}, {type : 'logic',
        token: {type      : 'Twig.logic.type.for',
            keyVar    : 'key',
            valueVar  : 'param',
            expression: [{type : 'Twig.expression.type.variable',
                value: 'params',
                match: ['params']}],
            output: [{type : 'raw',
                value: '            '}, {type : 'logic',
                token: {type : 'Twig.logic.type.if',
                    stack: [{type : 'Twig.expression.type.variable',
                        value: 'key',
                        match: ['key']}, {type : 'Twig.expression.type.number',
                        value: 0,
                        match: ['0', null]}, {type         : 'Twig.expression.type.operator.binary',
                        value        : '>',
                        precidence   : 8,
                        associativity: 'leftToRight',
                        operator     : '>'}],
                    output: [{type : 'raw',
                        value: ' / '}]}}, {type : 'logic',
                token: {type : 'Twig.logic.type.if',
                    stack: [{type : 'Twig.expression.type.variable',
                        value: 'param',
                        match: ['param']}, {type: 'Twig.expression.type.key.period',
                        key : 'type'}, {type : 'Twig.expression.type.string',
                        value: 'area'}, {type         : 'Twig.expression.type.operator.binary',
                        value        : '==',
                        precidence   : 9,
                        associativity: 'leftToRight',
                        operator     : '=='}],
                    output: [{type : 'output',
                        stack: [{type : 'Twig.expression.type.variable',
                            value: 'param',
                            match: ['param']}, {type: 'Twig.expression.type.key.period',
                            key : 'value'}]}]}}, {type : 'logic',
                token: {type  : 'Twig.logic.type.else',
                    match : ['else'],
                    output: [{type : 'output',
                        stack: [{type : 'Twig.expression.type.variable',
                            value: 'param',
                            match: ['param']}, {type: 'Twig.expression.type.key.period',
                            key : 'value'}]}, {type : 'raw',
                        value: ' '}, {type : 'output',
                        stack: [{type : 'Twig.expression.type.variable',
                            value: 'param',
                            match: ['param']}, {type: 'Twig.expression.type.key.period',
                            key : 'title'}]}]}}, {type : 'raw',
                value: '        '}]}}, {type : 'raw',
        value: '    </div>\n    <div class="flat-card__t-params">\n        <div class="flat-card__t-params-cell">\n            <div class="flat-card__t-params-name">'}, {type : 'output',
        stack: [{type : 'Twig.expression.type.variable',
            value: 'title',
            match: ['title']}, {type: 'Twig.expression.type.key.period',
            key : 'title'}]}, {type : 'raw',
        value: '</div>\n            <div class="flat-card__t-params-value">'}, {type : 'output',
        stack: [{type : 'Twig.expression.type.variable',
            value: 'title',
            match: ['title']}, {type: 'Twig.expression.type.key.period',
            key : 'value'}]}, {type : 'raw',
        value: '</div>\n        </div>\n        '}, {type : 'logic',
        token: {type      : 'Twig.logic.type.for',
            keyVar    : null,
            valueVar  : 'param',
            expression: [{type : 'Twig.expression.type.variable',
                value: 'params',
                match: ['params']}],
            output: [{type : 'raw',
                value: '            <div class="flat-card__t-params-cell">\n                <div class="flat-card__t-params-name">'}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'param',
                    match: ['param']}, {type: 'Twig.expression.type.key.period',
                    key : 'title'}]}, {type : 'raw',
                value: '</div>\n                <div class="flat-card__t-params-value">'}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'param',
                    match: ['param']}, {type: 'Twig.expression.type.key.period',
                    key : 'value'}]}, {type : 'raw',
                value: '</div>\n            </div>\n        '}]}}, {type : 'raw',
        value: '    </div>\n    '}, {type : 'logic',
        token: {type         : 'Twig.logic.type.include',
            only         : 4,
            ignoreMissing: false,
            stack        : [{type : 'Twig.expression.type.string',
                value: '69e6e512e5f59245a27dd55a9298619106fc6cbbde9e07e2c183152769e1bba49d0b2bab9a34036659cde37d27a19ad272d55d498f57eac64a1893b1dee85403'}],
            withStack: [{type : 'Twig.expression.type.object.start',
                value: '{',
                match: ['{']}, {type         : 'Twig.expression.type.operator.binary',
                value        : ':',
                precidence   : 16,
                associativity: 'rightToLeft',
                operator     : ':',
                key          : 'tags'}, {type : 'Twig.expression.type.variable',
                value: 'tags',
                match: ['tags']}, {type: 'Twig.expression.type.comma'}, {type         : 'Twig.expression.type.operator.binary',
                value        : ':',
                precidence   : 16,
                associativity: 'rightToLeft',
                operator     : ':',
                key          : 'class'}, {type : 'Twig.expression.type.string',
                value: 'flat-card__tags'}, {type: 'Twig.expression.type.comma'}, {type : 'Twig.expression.type.object.end',
                value: '}',
                match: ['}']}]}}, {type : 'raw',
        value: '    <div class="flat-card__image-wrapper">\n        <img class="flat-card__image" src="'}, {type : 'output',
        stack: [{type : 'Twig.expression.type.variable',
            value: 'image',
            match: ['image']}]}, {type : 'raw',
        value: '" alt="plan-image">\n    </div>\n    '}, {type : 'logic',
        token: {type         : 'Twig.logic.type.include',
            only         : 4,
            ignoreMissing: false,
            stack        : [{type : 'Twig.expression.type.string',
                value: 'c8018b70d51d946bcc823a5ec8f7a7cab1a7aff32db742be4300c9c03aacd22d991807db46b12de67a96c1004947e7e3f58cbe2f5fae0c6b5179e16612fdb934'}],
            withStack: [{type : 'Twig.expression.type.object.start',
                value: '{',
                match: ['{']}, {type         : 'Twig.expression.type.operator.binary',
                value        : ':',
                precidence   : 16,
                associativity: 'rightToLeft',
                operator     : ':',
                key          : 'items'}, {type : 'Twig.expression.type.variable',
                value: 'advantages',
                match: ['advantages']}, {type: 'Twig.expression.type.comma'}, {type         : 'Twig.expression.type.operator.binary',
                value        : ':',
                precidence   : 16,
                associativity: 'rightToLeft',
                operator     : ':',
                key          : 'class'}, {type : 'Twig.expression.type.string',
                value: 'flat-card__tooltips'}, {type: 'Twig.expression.type.comma'}, {type : 'Twig.expression.type.object.end',
                value: '}',
                match: ['}']}]}}, {type : 'raw',
        value: '    '}, {type : 'logic',
        token: {type         : 'Twig.logic.type.include',
            only         : 4,
            ignoreMissing: false,
            stack        : [{type : 'Twig.expression.type.string',
                value: '9e4be56dfd10b834627061ed7d00befac22b1b0f168e46a32ab4371d721337ca4ae2f0f51e720069630091ee487bf9925eea932c2b8e37e3e6357a103fcfbc44'}],
            withStack: [{type : 'Twig.expression.type.object.start',
                value: '{',
                match: ['{']}, {type         : 'Twig.expression.type.operator.binary',
                value        : ':',
                precidence   : 16,
                associativity: 'rightToLeft',
                operator     : ':',
                key          : 'price'}, {type : 'Twig.expression.type.variable',
                value: 'price',
                match: ['price']}, {type: 'Twig.expression.type.comma'}, {type         : 'Twig.expression.type.operator.binary',
                value        : ':',
                precidence   : 16,
                associativity: 'rightToLeft',
                operator     : ':',
                key          : 'oldPrice'}, {type : 'Twig.expression.type.variable',
                value: 'oldPrice',
                match: ['oldPrice']}, {type: 'Twig.expression.type.comma'}, {type         : 'Twig.expression.type.operator.binary',
                value        : ':',
                precidence   : 16,
                associativity: 'rightToLeft',
                operator     : ':',
                key          : 'class'}, {type : 'Twig.expression.type.string',
                value: 'flat-card__price'}, {type: 'Twig.expression.type.comma'}, {type : 'Twig.expression.type.object.end',
                value: '}',
                match: ['}']}]}}, {type : 'raw',
        value: '</div>\n'}],
    precompiled        : true,
    allowInlineIncludes: true,
    rethrow            : true});

module.exports = (context) => {
    return template.render(context);
}; Twig.twig({id  : '9e4be56dfd10b834627061ed7d00befac22b1b0f168e46a32ab4371d721337ca4ae2f0f51e720069630091ee487bf9925eea932c2b8e37e3e6357a103fcfbc44',
    data: [{type : 'raw',
        value: '<div class="flat-card-price'}, {type : 'logic',
        token: {type : 'Twig.logic.type.if',
            stack: [{type : 'Twig.expression.type.variable',
                value: 'class',
                match: ['class']}],
            output: [{type : 'raw',
                value: ' '}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'class',
                    match: ['class']}]}]}}, {type : 'raw',
        value: '">\n    '}, {type : 'logic',
        token: {type : 'Twig.logic.type.if',
            stack: [{type : 'Twig.expression.type.variable',
                value: 'oldPrice',
                match: ['oldPrice']}],
            output: [{type : 'raw',
                value: '        <div class="flat-card-price__prev">'}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'oldPrice',
                    match: ['oldPrice']}]}, {type : 'raw',
                value: '</div>\n    '}]}}, {type : 'raw',
        value: '    <div class="flat-card-price__current">'}, {type : 'output',
        stack: [{type : 'Twig.expression.type.variable',
            value: 'price',
            match: ['price']}, {type  : 'Twig.expression.type.filter',
            value : 'default',
            match : ['|default', 'default'],
            params: [{type : 'Twig.expression.type.parameter.start',
                value: '(',
                match: ['(']}, {type : 'Twig.expression.type.string',
                value: 'Цена по запросу'}, {type      : 'Twig.expression.type.parameter.end',
                value     : ')',
                match     : [')'],
                expression: false}]}]}, {type : 'raw',
        value: '</div>\n</div>\n'}],
    precompiled        : true,
    allowInlineIncludes: true,
    rethrow            : true}); Twig.twig({id  : 'c8018b70d51d946bcc823a5ec8f7a7cab1a7aff32db742be4300c9c03aacd22d991807db46b12de67a96c1004947e7e3f58cbe2f5fae0c6b5179e16612fdb934',
    data: [{type : 'raw',
        value: '<div class="flat-card-icons-tooltips'}, {type : 'logic',
        token: {type : 'Twig.logic.type.if',
            stack: [{type : 'Twig.expression.type.variable',
                value: 'class',
                match: ['class']}],
            output: [{type : 'raw',
                value: ' '}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'class',
                    match: ['class']}]}]}}, {type : 'raw',
        value: '">\n    '}, {type : 'logic',
        token: {type      : 'Twig.logic.type.for',
            keyVar    : null,
            valueVar  : 'item',
            expression: [{type : 'Twig.expression.type.variable',
                value: 'items',
                match: ['items']}],
            output: [{type : 'raw',
                value: '        <img class="flat-card-icons-tooltips__icon" src="'}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'item',
                    match: ['item']}, {type: 'Twig.expression.type.key.period',
                    key : 'icon'}]}, {type : 'raw',
                value: '" alt="'}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'item',
                    match: ['item']}, {type: 'Twig.expression.type.key.period',
                    key : 'title'}]}, {type : 'raw',
                value: '">\n    '}]}}, {type : 'raw',
        value: '</div>\n'}],
    precompiled        : true,
    allowInlineIncludes: true,
    rethrow            : true}); Twig.twig({id  : '69e6e512e5f59245a27dd55a9298619106fc6cbbde9e07e2c183152769e1bba49d0b2bab9a34036659cde37d27a19ad272d55d498f57eac64a1893b1dee85403',
    data: [{type : 'raw',
        value: '<div class="flat-card-tags'}, {type : 'logic',
        token: {type : 'Twig.logic.type.if',
            stack: [{type : 'Twig.expression.type.variable',
                value: 'class',
                match: ['class']}],
            output: [{type : 'raw',
                value: ' '}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'class',
                    match: ['class']}]}]}}, {type : 'raw',
        value: '">\n    '}, {type : 'logic',
        token: {type      : 'Twig.logic.type.for',
            keyVar    : null,
            valueVar  : 'tag',
            expression: [{type : 'Twig.expression.type.variable',
                value: 'tags',
                match: ['tags']}],
            output: [{type : 'raw',
                value: '        <div class="flat-card-tags__item">'}, {type : 'output',
                stack: [{type : 'Twig.expression.type.variable',
                    value: 'tag',
                    match: ['tag']}]}, {type : 'raw',
                value: '</div>\n    '}]}}, {type : 'raw',
        value: '</div>\n'}],
    precompiled        : true,
    allowInlineIncludes: true,
    rethrow            : true});
